import { render, staticRenderFns } from "./contestQuizzort.html?vue&type=template&id=22cd7707&scoped=true&external"
import script from "./contestQuizzort.js?vue&type=script&lang=js&external"
export * from "./contestQuizzort.js?vue&type=script&lang=js&external"
import style0 from "./contestQuizzort.scss?vue&type=style&index=0&id=22cd7707&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd7707",
  null
  
)

export default component.exports